import { render, staticRenderFns } from "./table-chengpin.vue?vue&type=template&id=5b591dae&scoped=true"
import script from "./table-chengpin.vue?vue&type=script&lang=js"
export * from "./table-chengpin.vue?vue&type=script&lang=js"
import style0 from "./table-chengpin.vue?vue&type=style&index=0&id=5b591dae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b591dae",
  null
  
)

export default component.exports